module.exports = __webpack_public_path__ + "img/violet_058.f06444bd.png";